<template>
  <div class="reportCenter">
    <el-menu
      class="reportCenter__menu"
      :text-color="'#B3B3B3'"
      background-color="#333333"
      :default-active="$route.name"
      @select="selectTag"
    >
      <el-menu-item index="remoteUpgradeFile">
        <span slot="title">远程升级文件</span>
      </el-menu-item>
      <el-menu-item index="remoteUpgradeLog">
        <span slot="title">远程升级日志</span>
      </el-menu-item>
      <el-menu-item index="driverManage">
        <span slot="title">绑定司机信息</span>
      </el-menu-item>
    </el-menu>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {};
  },
  // beforeRouteUpdate(to, from, next) {
  //   next();
  // },
  computed: {
    // ...mapState(["USER", "ROUTERNAME"])
  },
  methods: {
    ...mapMutations(["COMMIT_MAINTENANCETAG"]),
    async selectTag(key) {
      this.$route.name !== key && this.$router.push({ name: key });
      await this.COMMIT_MAINTENANCETAG(key);
    }
  }
};
</script>
<style lang="scss" scoped>
.el-menu {
  border-right: none;
}
.point {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #fff;
}
.reportCenter {
  height: 100%;
  background: #414141;
  display: flex;
  flex-direction: row;
  &__menu {
    width: 220px;
    @include scrollBar();
    overflow-y: auto;
    // margin-top: 50px;
    // padding: 15px;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    box-shadow: 2px 0px 4px 0px rgba(0, 0, 0, 0.05);
  }

  &__icon {
    margin-right: 10px;
    font-size: 6px;
  }
}
</style>
